import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "to"];
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Link as GatsbyLink } from '@reach/router';
var sites = {
  Marketing: 'MARKETING',
  Reference: 'REFERENCE',
  Docs: 'DOCS'
};

function environmentMatcher(loc) {
  var url = new URL(loc);

  if (loc.includes('/docs')) {
    return sites.Docs;
  } else if (loc.includes('/app') || loc.includes('.io/changelogs') || url.href === 'https://developer.frame.io' || url.href === 'https://developer.dev.frame.io') {
    return sites.Marketing;
  } else if (loc.includes('/operation') || loc.includes('/api')) {
    return sites.Reference;
  } else {
    return sites.Marketing;
  }
}

function isRelativeUrl(url) {
  var curLoc = window.location.href; // console.log('Current', curLoc);
  // console.log('Remote', url);

  var curEnvironment = environmentMatcher(curLoc);
  var linkEnvironment = environmentMatcher(url); // console.log("Current detected environment", curEnvironment)
  // console.log("Remote detected environment", linkEnvironment)

  if (curEnvironment == linkEnvironment) {
    return true;
  } else {
    return false;
  }
}

function isFrameioUrl(url) {
  // console.log(url)
  if (url.includes('frame.io')) {
    return true;
  } else {
    return false;
  }
}

var Link = function Link(_ref) {
  var children = _ref.children,
      to = _ref.to,
      others = _objectWithoutProperties(_ref, _excluded);

  var url = new URL(to); // Triggered when it's an external URL (non-developer site)

  if (!isFrameioUrl(to)) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: to
    }, others), children);
  } // Triggered when it's a non-relative link (between sites)


  if (!isRelativeUrl(to)) {
    // console.log("Returning an absolute URL", to)
    return /*#__PURE__*/React.createElement("a", _extends({
      href: to
    }, others), children);
  } // Triggered when it's definitely a relative link!


  if (isRelativeUrl(to)) {
    // console.log("Returning a relative URL", url.pathname)
    return /*#__PURE__*/React.createElement(GatsbyLink, _extends({
      to: url.pathname
    }, others), children);
  } // This is our fallback I guess (but I don't think it'll ever happen)


  return /*#__PURE__*/React.createElement("a", _extends({
    href: to,
    target: "_blank",
    rel: "noopener noreferrer"
  }, others), children);
};

export { environmentMatcher, isRelativeUrl, isFrameioUrl, Link };